// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4h-2";
export var blackBorderOnHover = "_4h-7";
export var cell = "_4h-6";
export var cellContainer = "_4h-3";
export var checked = "_4h-8";
export var disabled = "_4h-5";
export var featuredIconCellContainer = "_4h-9";
export var featuredIconTextContainer = "_4h-b";
export var featuredIconWrapper = "_4h-a";
export var noBorder = "_4h-c";
export var orangeSelectedRow = "_c8-3";
export var overflowableText = "_4h-0";
export var overflowableTextContainer = "_4h-1";
export var row = "_4f-0";
export var rowCheckboxCell = "_4h-4";
export var selectableTable = "_c8-2";